// extracted by mini-css-extract-plugin
export default {"giveUp_button":"completedGame_giveUp_button__ftT-a"};